import React, { type SVGProps } from 'react';

export const FacebookIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg width="15" height="28" viewBox="0 0 15 28" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.60606 9.33333H0V14H3.60606V28H9.61616V14H13.9939L14.4242 9.33333H9.61616V7.3885C9.61616 6.27433 9.84695 5.83333 10.9564 5.83333H14.4242V0H9.84695C5.52449 0 3.60606 1.84683 3.60606 5.38417V9.33333Z"
        />
    </svg>
);
